import DropdownViewModel from "../../Utilities/ViewModels/DropdownViewModel";
import ManagerDropdownViewModel from "./ManagerDropdownViewModel";

export default class TeamListViewModel {
    public name: string = '';
    public members: DropdownViewModel[] = [];
    public managers: ManagerDropdownViewModel[] = [];
}